module.exports = __webpack_public_path__ + "static/media/logo_white.0478203d.png";